import { ListEventsResponse } from '@wavingroup/aqora-v2-crate/wavin/aqora/v2/aqora_service_pb';
import { EventType } from '@wavingroup/aqora-v2-crate/wavin/aqora/v2/event_pb';
import { aqoraClient } from '~/services/api/aqora-client';

const EVENTS_PAGE_SIZE = BigInt(200);

export const listEvents = async ({
  resourceName,
  filterTypes,
}: {
  resourceName: string;
  pageSize?: number;
  filterTypes?: EventType[];
}): Promise<ListEventsResponse> =>
  await aqoraClient.listEvents({
    pageSize: EVENTS_PAGE_SIZE,
    resourceName,
    filterTypes,
  });
